
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigResponse} from './ConfigResponse';
import {FieldModelConfigResponse} from './ConfigResponse';
import {AccountState} from '../core/AccountState';
import {FieldModelAccountState} from '../core/AccountState';
import {OrderState} from '../core/OrderState';
import {FieldModelOrderState} from '../core/OrderState';

/**
 * AccountStatesGetAllResponse struct
 */
class AccountStatesGetAllResponse extends ConfigResponse {
  /**
   * Initialize struct
   * @param {!ConfigResponse=} parent
   * @param {!Array=} accountStates
   * @param {!Array=} orderStates
   * @constructor
   */
  constructor (parent = new ConfigResponse(), accountStates = [], orderStates = []) {
    super()
    super.copy(parent)
    this.AccountStates = accountStates
    this.OrderStates = orderStates
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountStatesGetAllResponse}
   * @param {!AccountStatesGetAllResponse} other Other struct
   * @returns {!AccountStatesGetAllResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.AccountStates != null) {
      this.AccountStates = []
      for (let item of other.AccountStates) {
        if (item != null) {
          let tempItem
          tempItem = AccountState.fromObject(item)
          this.AccountStates.push(tempItem)
        } else {
          this.AccountStates.push(null)
        }
      }
    } else {
      this.AccountStates = null
    }
    if (other.OrderStates != null) {
      this.OrderStates = []
      for (let item of other.OrderStates) {
        if (item != null) {
          let tempItem
          tempItem = OrderState.fromObject(item)
          this.OrderStates.push(tempItem)
        } else {
          this.OrderStates.push(null)
        }
      }
    } else {
      this.OrderStates = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountStatesGetAllResponse}
   * @returns {!AccountStatesGetAllResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountStatesGetAllResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountStatesGetAllResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountStatesGetAllResponse}
   * @param {!AccountStatesGetAllResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountStatesGetAllResponse)) {
      throw new TypeError('Instance of AccountStatesGetAllResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountStatesGetAllResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      AccountStates: ((this.AccountStates != null) ? Array.from(this.AccountStates, item => ((item != null) ? item : null)) : null),
      OrderStates: ((this.OrderStates != null) ? Array.from(this.OrderStates, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountStatesGetAllResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountStatesGetAllResponse} other Object value
   * @returns {!AccountStatesGetAllResponse} Created struct
   */
  static fromObject (other) {
    return new AccountStatesGetAllResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountStatesGetAllResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountStatesGetAllResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountStatesGetAllResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6369
  }
}

export { AccountStatesGetAllResponse };

/**
 * Fast Binary Encoding AccountStatesGetAllResponse field model
 */
class FieldModelAccountStatesGetAllResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigResponse(buffer, 4 + 4)
    this.AccountStates = new fbe.FieldModelVector(new FieldModelAccountState(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.OrderStates = new fbe.FieldModelVector(new FieldModelOrderState(buffer, this.AccountStates.fbeOffset + this.AccountStates.fbeSize), buffer, this.AccountStates.fbeOffset + this.AccountStates.fbeSize)
  }

  /**
   * Get the ConfigResponse field model
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!FieldModelConfigResponse} ConfigResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.AccountStates.fbeSize + this.OrderStates.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.AccountStates.fbeExtra + this.OrderStates.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountStatesGetAllResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6369
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.AccountStates.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountStates.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountStates.fbeSize

    if ((fbeCurrentSize + this.OrderStates.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStates.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStates.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!AccountStatesGetAllResponse} fbeValue Default value, defaults is new AccountStatesGetAllResponse()
   * @returns {!AccountStatesGetAllResponse} AccountStatesGetAllResponse value
   */
  get (fbeValue = new AccountStatesGetAllResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!AccountStatesGetAllResponse} fbeValue AccountStatesGetAllResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.AccountStates.fbeSize) <= fbeStructSize) {
      this.AccountStates.get(fbeValue.AccountStates)
    } else {
      fbeValue.AccountStates.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountStates.fbeSize

    if ((fbeCurrentSize + this.OrderStates.fbeSize) <= fbeStructSize) {
      this.OrderStates.get(fbeValue.OrderStates)
    } else {
      fbeValue.OrderStates.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStates.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {!AccountStatesGetAllResponse} fbeValue AccountStatesGetAllResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountStatesGetAllResponse}
   * @param {AccountStatesGetAllResponse} fbeValue AccountStatesGetAllResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.AccountStates.set(fbeValue.AccountStates)
    this.OrderStates.set(fbeValue.OrderStates)
  }
}

export { FieldModelAccountStatesGetAllResponse };

/**
 * Fast Binary Encoding AccountStatesGetAllResponse model
 */
class AccountStatesGetAllResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountStatesGetAllResponse(this.buffer, 4)
  }

  /**
   * Get the AccountStatesGetAllResponse model
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!FieldModelAccountStatesGetAllResponse} model AccountStatesGetAllResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountStatesGetAllResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountStatesGetAllResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountStatesGetAllResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountStatesGetAllResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountStatesGetAllResponseModel}
   * @param {!AccountStatesGetAllResponse} value AccountStatesGetAllResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountStatesGetAllResponseModel}
   * @param {!AccountStatesGetAllResponse} value AccountStatesGetAllResponse value, defaults is new AccountStatesGetAllResponse()
   * @return {!object} Deserialized AccountStatesGetAllResponse value and its size
   */
  deserialize (value = new AccountStatesGetAllResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountStatesGetAllResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountStatesGetAllResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountStatesGetAllResponseModel}
   * @param {!number} prev Previous AccountStatesGetAllResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountStatesGetAllResponseModel };
